import { createStateContext } from 'react-use';

import { type SubscriptionBillingCycle } from '@air/api/types';

const [useBillingCycle, BillingCycleProvider] = createStateContext<SubscriptionBillingCycle>('annual');

export { BillingCycleProvider, useBillingCycle };
